export interface ICustomerType {
    id: string;
    code: string;
    name: string;
}

export class CustomerType implements ICustomerType {
    id: string;
    code: string;
    name: string;

    constructor();
    constructor(obj: ICustomerType);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
    }
}